import { setElementVisibility } from '../html';

export enum Route {
  agentic = 'agentic',
  canvas = 'canvas',
  dialogs = 'dialogs',
  intents = 'intents',
  save = 'save',
  settings = 'settings',
  testTool = 'testTool'
}

export function navigateToRoute(newRoute: Route) {
  document.querySelectorAll('.nav-button').forEach((element) => {
    element.classList.remove('selected');
  });
  document.getElementById(`${newRoute}-nav`)?.classList.add('selected');

  Object.values(Route).forEach((route) => {
    setElementVisibility(`#${route}`, route === newRoute);
  });
  const isCanvas = newRoute === Route.canvas;
  setElementVisibility('#left-panels', isCanvas);
  setElementVisibility('#right-panels', isCanvas);
  window.w2ui.layout[(isCanvas) ? 'showTabs' : 'hideTabs']('main');
  window.w2ui.layout[(isCanvas) ? 'showToolbar' : 'hideToolbar']('main');

  // Update the URL path without reloading the page using `pushState`.
  // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
  const { pathname, search, hash } = window.location;
  const searchWithHash = `${search}${hash}`;

  // Default to the main `/app/` route.
  let newPath = `/app/${searchWithHash}`;

  // Make sure update the URL via `pushState`
  // only when navigating into the intents tab.
  if (newRoute === Route.intents) {
    // If they come from any of the other top level tabs (like `Canvas`)
    // then redirect to the intent management route, if not then
    // we want to keep the path they are coming from in case there's
    // a route on `IntentLayout` that matches that path.
    newPath = pathname.includes('/intent/')
      ? `${pathname}${searchWithHash}`
      : `/app/intent${searchWithHash}`;
  }

  window.history.pushState(null, '', newPath);
}
